import { post,get} from '@/libs/ajax.js'

/**
 * 获取数据 展开状态
 * @returns 
 */
export function getMaterialConditionAreaStateApi() {
    return get('/material_analysis/get_condition_area_state')
}
/**
 * 设置固定状态
 * @returns 
 */
export function setMaterialConditionAreaStateApi(data) {
    return post('/material_analysis/set_condition_area_state', data)
}
/**
 * 保存 更新 模板
 * @param {*} data 
 * @returns 
 */
export function addAndUpdateMaterialTemplateApi(data) {
    return post('/material_analysis/template/plat/add', data)
}
/**
 * 获取模板数据
 * @param {*} data 
 * @returns 
 */
export function getMaterialTempListApi(data) {
    return get('/material_analysis/template/plat/list', data)
}
/**
 * 删除模板
 * @param {*} data 
 * @returns 
 */
export function delMaterialTempApi(data) {
    return post('/material_analysis/template/plat/del', data)
}
/**
 * 置顶
 * @param {*} data 
 * @returns 
 */
export function topMaterialTempApi(data) {
    return post('/material_analysis/template/plat/set_top', data)
}
/**
 * 设置为默认
 * @param {*} data 
 * @returns 
 */
export function defaultMaterialTempApi(data) {
    return post('/material_analysis/template/plat/set_default', data)
}
/**
 * 获取模板数据
 * @param {*} data 
 * @returns 
 */
export function getMaterialTempApi(data) {
    return get('/material_analysis/template/plat/get', data)
}
/**
 * 获取默认模板
 * @param {*} data 
 * @returns 
 */
export function getDefMaterialTempApi(data) {
    return get('/material_analysis/template/plat/get_default', data)
}
/**
 * 修改模板名称
 * @param {*} data 
 * @returns 
 */
export function updateMaterialTempNameApi(data) {
    return post('/material_analysis/template/plat/modify_name', data)
}
/**
 * 获取查询数据
 * @param {*} data 
 * @returns 
 */
export function getMaterialListApi(data) {
    return post('/material_analysis/plat/get_list', data)
}

/**
 * 获取筛选数据
 * @param {*} data 
 * @returns 
 */
export function getMaterialConditionListApi(data) {
    return post('/material_analysis/plat/get_condition', data)
}
/**
 * 获取禁用日期
 * @param {*} data 
 * @returns 
 */
export function getMaterialDisableDateApi(data) {
    return post('/material_analysis/plat/get_disable_date', data)
}
/**
 * 二次筛选查询列表
 * @param {*} data 
 * @returns 
 */
export function getMaterialSecondConditionListApi(data) {
    return post('/material_analysis/plat/get_second_condition', data)
}
/**
 * 下载无水印素材
 * @param {*} data 
 * @returns 
 */
export function downloadMaterialNoWatermarkApi(data) {
    return post('/material_analysis/plat/download_material_without_watermark', data)
}
/**
 * 下载水印素材
 * @param {*} data 
 * @returns 
 */
export function downloadMaterialWatermarkApi(data) {
    return post('/material_analysis/plat/download_material_with_watermark', data)
}